export const api = {
  login: '/api/login',
  instrument: '/api/instrument',
  instruments: '/api/instruments',
  sterylize: '/api/instrument/sterilizare',
  reviews: '/api/reviews',
  markHistory: '/api/mark-history',
  handle_note: '/api/handle-note',
  delete_note: '/api/delete-note',
  log_error: '/api/log-error',
  create_appointment: '/calendar/create-appointment-icalendar',
  update_appointment: '/calendar/update-appointment-icalendar',
  delete_appointment: '/calendar/delete-appointment-icalendar',

  treatment_frequency: '/api/analytics/treatment-frequency',
  treatment_correlations: '/api/analytics/treatment-correlations',
  igienizare_overdue: '/api/analytics/igienizare-overdue',
  treatment_duration_value: '/api/analytics/treatment-duration-value',
  recurrence_loyalty: '/api/analytics/patient-retention',
  doctor_continuity:'/api/analytics/doctor-continuity'
}
